import { FC } from 'react';
import ENVIRONMENT from 'config/environment';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface RequestIconProps {
  formId: string | number;
  style?: React.CSSProperties;
}

const mapURLRequestIcons: Record<number, string> = {
  13: 'ClapperBoard',
};

const RequestIcon: FC<RequestIconProps> = ({ formId, style }) => {
  const listFormsData = useSelector((state: RootState) => state.resources.requestForms);

  const id = Number(formId);
  const iconFromList = listFormsData.find((item) => item.id === id)?.icon;
  const icon = iconFromList ?? mapURLRequestIcons[id] ?? 'Cyclone';

  return (
    <img alt="request-icon" src={`${ENVIRONMENT.CDN_ASSETS_URL}/requests/icons/${icon}.svg`} style={{ width: 24, ...style }} />
  );
};

export default RequestIcon;
